"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _dealerDetails = _interopRequireDefault(require("../../styles/dealerDetails.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var DealerDetailsSecondaryHeading = function DealerDetailsSecondaryHeading(_ref) {
  var headingText = _ref.headingText,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(headingText)) {
    return /*#__PURE__*/_react["default"].createElement("h2", {
      className: _dealerDetails["default"].secondaryHeadingText + " " + theme.marginTop30 + " " + theme.marginBottom10 + " " + (theme ? theme.headingSix : '')
    }, headingText);
  }
  return null;
};
var _default = DealerDetailsSecondaryHeading;
exports["default"] = _default;